import React from 'react';
import { Clock3 } from 'lucide-react';
import { Link } from 'react-router-dom';
import { automationOutcome } from '../../utils/automationOutcome';

export default function AutomationOutcomeBanner({ result }) {
  const outcome = automationOutcome(result);
  if (!outcome) return null;
  return (
    <div className="mt-1.5 rounded-md border border-blue-200 bg-blue-50 px-2 py-1.5 text-xs text-blue-800 dark:border-blue-800 dark:bg-blue-900/30 dark:text-blue-300">
      <div className="flex items-center gap-1.5">
        <Clock3 className="h-3.5 w-3.5 shrink-0" aria-hidden="true" />
        <span>{outcome.message}</span>
      </div>
      {result.pending_communication_ids?.length > 0 && (
        <Link to="/app/ai-actions?tab=pending" className="mt-1 inline-block underline">
          Review Pending Workflow Actions ({result.pending_communication_ids.length})
        </Link>
      )}
    </div>
  );
}
